export type NavItem = Readonly<{ label: string; href: `#${string}` }>;
export type Service = Readonly<{
  action: string;
  name: string;
  description: string;
}>;

export const navigation: readonly NavItem[] = [
  { label: 'Обо мне', href: '#about' },
  { label: 'Услуги', href: '#services' },
  { label: 'Проект', href: '#project' },
  { label: 'Контакты', href: '#contact' },
];

export const services: readonly Service[] = [
  {
    action: 'Понять.',
    name: 'Стратегия и аудит',
    description: 'Изучаю задачу, аудиторию и точки роста.',
  },
  {
    action: 'Привлечь.',
    name: 'Meta Ads',
    description: 'Выстраиваю рекламу и понятную коммуникацию.',
  },
  {
    action: 'Убедить.',
    name: 'Сайты и лендинги',
    description: 'Создаю страницы, на которых ясно, что вы предлагаете.',
  },
  {
    action: 'Измерить.',
    name: 'Аналитика GA4 · GTM',
    description: 'Настраиваю измерение и помогаю читать результаты.',
  },
];

const buildEnv = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env;

export const featureFlags = {
  analytics: buildEnv?.VITE_ENABLE_ANALYTICS === 'true',
  motion: buildEnv?.VITE_ENABLE_MOTION !== 'false',
  contactLinks: true,
  caseLink: true,
} as const;

export const media = {
  heroPortrait: {
    status: 'approved' as const,
    src: '/media/alexander-828.jpg',
    srcSet: '/media/alexander-480.jpg 480w, /media/alexander-828.jpg 828w',
    width: 828,
    height: 828,
  },
  inBalanceScreenshot: {
    status: 'approved' as const,
    src: '/media/in-balance-1697.jpg',
    srcSet: '/media/in-balance-900.jpg 900w, /media/in-balance-1697.jpg 1697w',
    width: 1697,
    height: 898,
  },
} as const;

export const contacts = {
  email: 'al.soldatjonoks@gmail.com',
  emailHref: 'mailto:al.soldatjonoks@gmail.com',
  instagram: '@alexads.agency',
  instagramHref: 'https://www.instagram.com/alexads.agency/',
  phone: '+371 20 079 567',
  phoneHref: 'tel:+37120079567',
} as const;

export const projectUrl = 'https://inbalancestudija.lv/' as const;
